"use client";
import React from "react";
import { usePathname } from "next/navigation";

import TopBar from "@cobasi/ds-components-react/dist/containers/TopBar";
import Header from "@cobasi/ds-components-react/dist/containers/Header";
import Footer from "@cobasi/ds-components-react/dist/containers/Footer";

export type BaseProps = {
  children: React.ReactNode;
  isLoading?: boolean;
};

const Base = ({ children }: BaseProps) => {
  const pathname = usePathname();

  return (
    <>
      <TopBar />
      <Header
        $darkmode={false}
        returnUrl={pathname || ""}
        indexId="ddfbf1ba66c5f0828ce406bad8ff5e4c1745832765"
      />
      {children}
      <Footer $darkmode={false} />
    </>
  );
};

export default Base;
